module.exports = __webpack_public_path__ + "img/1F63B.74ca415c.svg";